import { render, staticRenderFns } from "./DashboardTab.vue?vue&type=template&id=4190727e&scoped=true&"
import script from "./DashboardTab.vue?vue&type=script&lang=js&"
export * from "./DashboardTab.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTab.vue?vue&type=style&index=0&id=4190727e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4190727e",
  null
  
)

export default component.exports